import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Order, UboTreeNode, UboTreeNodesService } from 'reg-hub-common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-link-to-hub-report-dialog',
  templateUrl: './link-to-hub-report-dialog.component.html',
  styleUrl: './link-to-hub-report-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LinkToHubReportDialogComponent implements OnInit {
  protected nodes: UboTreeNode[] = [];
  protected displayNodes: UboTreeNode[] = [];
  protected order!: Order;
  protected selectedNode?: UboTreeNode;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { order: Order },
    private uboTreeService: UboTreeNodesService,
    private router: Router) {
    this.order = data.order;
  }

  ngOnInit() {
    this.nodes = this.uboTreeService.linkToHubReportNodes.value;
    this.displayNodes = this.uboTreeService.linkToHubReportNodesDistinctByHubReport.value;
  }

  protected onHubReportCheckboxClick(node: UboTreeNode) {
    if (this.selectedNode === node) {
      this.selectedNode = undefined;
    } else {
      this.selectedNode = node;
    }
  }

  protected onLink() {
    if (this.selectedNode) {
      const nodesToLinkTo = this.nodes.filter(n => n.hubReportID === this.selectedNode?.hubReportID);
      forkJoin(nodesToLinkTo.map(n => this.uboTreeService.addOrderToNode(n.id, this.order.id))).subscribe(() => {
        this.router.navigate(['hubreportsv2', this.selectedNode?.hubReportID]); //UBO2TODO: update path
      });
    }
  }
}